
import { TableComponent } from 'components/TableComponent';

export type TableRowProps = {
  children: React.ReactElement;
};

type TableContentProps = {
  children: React.ReactNode;
};
// Table component used in SelectProjectPage
export const SelectProjectTableContent = ({
  children,
}: TableContentProps) => {
  return (
    <TableComponent.TableContainer>
      <TableComponent.Table>
        <TableComponent.TableBody style={{ maxHeight: '20rem', overflowY: 'scroll' }}>
          {children}
        </TableComponent.TableBody>
      </TableComponent.Table>
    </TableComponent.TableContainer>
  );
};
